<template>
  <div style="display:inline-block;" :class="this.spacingTop && 'has-spacing-top'">
    <a :class="linkClasses" @click="abrirModalCallToAction">
      <svg v-if="iconName" :class="svgClasses">
        <use
          xmlns:xlink="http://www.w3.org/1999/xlink"
          :href="`/assets/svg/user/icons.svg#${iconName}`"
        ></use>
      </svg>
      <span>{{ label }}</span>
    </a>
    <call-to-action-autos-pagina-publica
      v-if="showCallToActionAutosPaginaPublica"
      :processo="processo"
      :campanha-id="campanhaId"
      @close="close"
    />
  </div>
</template>
<script>
import CallToActionAutosPaginaPublica from "../../components/modals/CallToActionAutosPaginaPublica";
export default {
  components: {
    CallToActionAutosPaginaPublica,
  },
  props: {
    linkClasses: {
      default: "btn -hasIcon",
      type: String
    },
    processo: {
      default: null,
      type: String
    },
    spacingTop: {
      type: Boolean,
      default: false
    },
    campanhaId: {
      type: String,
      default: ''
    },
    svgClasses: {
      default: "svg-icon -x20 -right -highlight",
      type: String
    },
    iconName: {
      default: "",
      type: String
    }
  },
  data() {
    return {
      label: "Autos do processo",
      showCallToActionAutosPaginaPublica: false,
      titleModalNaoAssinante: "",
      errorMessage: ""
    };
  },
  mounted() {
  },
  computed: {
  },
  methods: {
    abrirModalCallToAction() {
      this.showCallToActionAutosPaginaPublica = true;
    },
    close() {
      this.showCallToActionAutosPaginaPublica = false;
    },
  }
};
</script>
<style lang="stylus">
.is-hidden
  display none
.has-spacing-top
  margin-top 0.5rem
</style>
